const steps = [
  'Call or message us',
  'We diagnose and give options',
  'We fix it fast',
];

export default function HowItWorks() {
  return (
    <section className="bg-gradient-to-b from-light-cyan to-white py-20 md:py-24 relative overflow-hidden">
      {/* Decorative Water Droplets */}
      <div className="absolute top-20 left-10 opacity-5">
        <i className="ri-drop-line text-tropical-teal text-6xl"></i>
      </div>
      <div className="absolute bottom-20 right-20 opacity-5">
        <i className="ri-drop-line text-tropical-teal text-8xl"></i>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-charcoal text-center mb-14">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connecting Dotted Line - Desktop Only */}
          <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 border-t-2 border-dashed border-tropical-teal/30 z-0" style={{ top: '80px' }}></div>

          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-10 shadow-lg relative z-10"
              style={{ boxShadow: '0 6px 16px rgba(77, 208, 225, 0.12)' }}
            >
              <div className="w-14 h-14 bg-coral-pink rounded-full flex items-center justify-center mb-6">
                <span className="text-white font-bold text-2xl">{index + 1}</span>
              </div>
              <p className="text-xl text-charcoal font-medium leading-relaxed">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}